<template>
    <div class="container">
        <vue-headful
                title="Deleted Users - SIC Dashboard"
        />
        <div class="row">
            <div class="col-md-12 mt-5 mb-5">
                <div class="card shadow">
                    <div class="card-header border-0">
                        <div class="row align-items-center">
                            <div class="col">
                                <h3 class="mb-0">Deleted Users</h3>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="alert alert-danger text-capitalize">
                            Deleting a user here will permanently delete the user from server as well as all
                            all of the content belonging to this user like user profile, all ideas of this user and comments
                            by that user.
                        </div>
                        <div class="alert alert-info text-capitalize">
                            User can be recovered by clicking on the recover button.
                        </div>
                    </div>
                    <div class="table-responsive">
                        <!-- Projects table -->
                        <table class="table align-items-center table-flush">
                            <thead class="thead-light">
                            <tr>
                                <th>Actions</th>
                                <th scope="col">User ID</th>
                                <th scope="col">Username</th>
                                <th scope="col">Name</th>
                                <th scope="col">Email</th>
                                <th scope="col">User Type</th>
                                <th scope="col">Profile Views</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="user in allUsers" :key="user.id">
                                <td>
                                    <button @click="permanentDelete(user.id)" type="button"
                                            class="btn btn-danger fas fa-trash" data-toggle="tooltip"
                                            data-placement="top" title="Delete User"></button>
                                    <button @click="recoverUser(user.id)" type="button" class="btn btn-success fas fa-undo"
                                            data-toggle="tooltip" data-placement="top" title="Edit User"></button>
                                </td>
                                <th scope="row">
                                    {{user.id}}
                                </th>
                                <td scope="row">
                                    <strong>{{user.username}}</strong>
                                </td>
                                <td>
                                    <span class="" v-for="profile in user.profile" :key="profile.id">
                                        {{profile.first_name}} {{profile.last_name}}
                                    </span>

                                </td>
                                <td>
                                    {{user.email}}
                                </td>
                                <td>
                                    <span v-if="user.user_type == 1" class="text-green">Student</span>
                                    <span v-else class="text-info">Startup</span>
                                </td>
                                <td>
                                    {{user.profile_views}}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="card shadow pt-3 d-flex justify-content-center">
                    <pagination pagination="pagination"></pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import vueHeadful from "vue-headful";
import laravelPagination from "../components/LaravelPagination";
import _ from "lodash";

export default {
  data() {
    return {
      allUsers: {},
      pagination: {}
    };
  },
  mounted() {
    this.getAllUsers();
  },
  methods: {
    getAllUsers() {
      axios({
        url:
          "admin/website/users/deleted?access_token=" +
          localStorage.getItem("access_token"),
        method: "get",
        body: {},
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.allUsers = result.data.users.data;
            this.pagination = {
              currentPage: result.data.users.current_page,
              lastPage: result.data.users.last_page,
              firstPageUrl: result.data.users.first_page_url,
              lastPageUrl: result.data.users.last_page_url,
              nextPageUrl: result.data.users.next_page_url,
              previousPageUrl: result.data.users.prev_page_url,
              perPage: result.data.users.per_page,
              from: result.data.users.from,
              to: result.data.users.to,
              total: result.data.users.total
            };
          },
          error => {
            console.log(error.response);
          }
        )
        .catch(e => {
          console.log(e);
        });
    },
    permanentDelete(id) {
      axios({
        method: "delete",
        url: "admin/website/users/permanent-delete/" + id,
        data: {
          access_token: localStorage.getItem("access_token")
        },
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.$swal(
              "User Deleted Permanently",
              _.startCase(
                "All of the user content like user profile, users ideas, user notifications, user analytics and user comments are also deleted."
              ),
              "success"
            );
            console.log(result);
            this.getAllUsers();
          },
          error => {
            this.$swal(
              "Error",
              "There was an error. Please try again",
              "error"
            );
            console.log(error.response);
            let errors = error.response.data.error;
            for (let error in errors) {
              this.$noty.error("Error: " + _.startCase(errors[error][0]));
            }
          }
        )
        .catch(e => {
          console.log(e);
        });
    },
    recoverUser(id) {
      axios({
        method: "put",
        url: "admin/website/users/recover/" + id,
        data: {
          access_token: localStorage.getItem("access_token")
        },
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.$swal("User Recovered Successfully", "", "success");
            this.getAllUsers();
            console.log(result);
          },
          error => {
            this.$swal(
              "Error",
              "There was an error. Please try again",
              "error"
            );
            let errors = error.response.data.error;
            for (let error in errors) {
              this.$noty.error("Error: " + _.startCase(errors[error][0]));
            }
          }
        )
        .catch(e => {
          console.log(e);
        });
    }
  },
  computed: {},
  components: {
    "vue-headful": vueHeadful,
    pagination: laravelPagination
  }
};
</script>

<style scoped>
</style>
